/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const citySearchCountryDataSchema = z.object({
	id: z.string(),
	name: z.string(),
})

export type CitySearchCountryDataSchema = z.infer<typeof citySearchCountryDataSchema>
